import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { DialogTitleWithClose } from 'ui';
import { industries } from 'shared/constants/industries';

const useStyles = makeStyles({
  table: {
    '& td': {
      verticalAlign: 'top',
    },
  },
  primary: {
    fontWeight: 'bold',
  },
});

const ViewIndustriesModal = ({ open, onClose, ...props }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth {...props}>
      <DialogTitleWithClose onClose={onClose}>{t('Industries')}</DialogTitleWithClose>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableBody>
              {industries.map(({ aggregate, includes }) => (
                <TableRow key={aggregate}>
                  <TableCell>
                    <Typography className={classes.primary}>{t(aggregate)}</Typography>
                  </TableCell>
                  <TableCell>
                    {includes.map(include => (
                      <Typography key={include}>{t(include)}</Typography>
                    ))}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

ViewIndustriesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  industries: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export { ViewIndustriesModal };
